module.exports = __webpack_public_path__ + "static/media/to-be-confirmed.2778d8db.svg";